export var createWebStorage = function createWebStorage() {
  if (typeof localStorage === 'undefined') return;
  return {
    get: function get(key) {
      return Promise.resolve(localStorage.getItem(key));
    },
    set: function set(key, value) {
      return Promise.resolve(localStorage.setItem(key, value));
    },
    remove: function remove(key) {
      return Promise.resolve(localStorage.removeItem(key));
    }
  };
};